import React from "react";
import { Container } from "reactstrap";

const Header = () => {
  return (
    <>
      <div className="header pt-5 pt-lg-8">
        <Container fluid></Container>
      </div>
    </>
  );
};

export default Header;
